import { Box, styled } from '@mui/material';
import { FC } from 'react';
import logo from '../../assets/images/feral-scan/feralscan_map.png';

const LoadingContainer = styled(Box)(() => ({
    width: '100%',
    height: '100%',
    position: 'relative',
    margin: '50px auto',
    overflow: 'hidden',
}));

const LoadingImage = styled(Box)(() => ({
    width: '100%',
    height: '100%',
    opacity: 0,
    animation: 'reveal 3s infinite',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const globalStyles = `
    @keyframes reveal {
        0% {
            opacity: 0;
            transform: translateY(10px); /* Starting position */
        }
        50% {
            opacity: 1;
            transform: translateY(0); /* Middle position */
        }
        100% {
            opacity: 0;
            transform: translateY(10px); /* End position */
        }
    }
`;

// Append the global styles to the document head
const appendGlobalStyles = () => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = globalStyles;
    document.head.appendChild(styleTag);
};

const Loader: FC = () => {
    // Ensure the global styles are applied
    appendGlobalStyles();

    return (
        <LoadingContainer>
            <LoadingImage>
                <img src={logo} alt="Loading" />
            </LoadingImage>
        </LoadingContainer>
    );
};

export default Loader;
